import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Panel from 'react-bootstrap/lib/Panel';
import { aOrAn } from 'helpers/HelperFunctions';

export default class ProjectBuyerUpsell extends Component {
  static propTypes = {
    project: PropTypes.object,
    suggestedRoles: PropTypes.array,
    suggestedSkills: PropTypes.array,
  };

  constructor() {
    super();

    this.state = {
      talentRoles: [],
      talentSkills: [],
    };
  }

  componentDidMount() {
    if (this.props.project) {
      this.initRolesSkills();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.project !== prevProps.project) {
      this.initRolesSkills();
    }
  }

  initRolesSkills() {
    let talentRoles = this.props.project.tags.map((tag) => {
      let roleElement = null;
      this.props.suggestedRoles.forEach((role) => {
        if (
          typeof role !== 'undefined' &&
          (role.slug.replace('-', '') === tag ||
            role.slug_plural.replace('-', '') === tag)
        ) {
          roleElement = (
            <div className="text-center mb--">
              <a href={'/find/' + role.slug_plural} style={{ color: 'white' }}>
                Hire {aOrAn(role.name)} {role.name}
              </a>
            </div>
          );
        }
      });

      return roleElement;
    });

    let talentSkills = this.props.project.tags.map((tag) => {
      let skillElement = null;
      this.props.suggestedSkills.forEach((skill) => {
        if (
          typeof skill !== 'undefined' &&
          (skill.slug.replace('-', '') === tag ||
            skill.slug_plural.replace('-', '') === tag)
        ) {
          skillElement = (
            <div className="text-center mb--">
              <Link to={'/get/' + skill.slug_plural} style={{ color: 'white' }}>
                Get your {skill.name}
              </Link>
            </div>
          );
        }
      });

      return skillElement;
    });

    talentRoles = talentRoles.filter((role) => role);
    talentSkills = talentSkills.filter((role) => role);

    if (talentRoles.length <= 0 && talentSkills.length <= 0) {
      let randomRoles = [
        'graphicdesigner',
        'illustrator',
        'imageeditor',
        'uxdesigner',
      ];
      if (this.props.project.mediaType === 'audio') {
        randomRoles = ['vocalist', 'dj', 'musicproducer', 'musician'];
      } else if (this.props.project.mediaType === 'video') {
        randomRoles = [
          'filmproducer',
          'videoeditor',
          'cameraoperator',
          'postproduction',
        ];
      }

      randomRoles = [
        randomRoles[Math.floor(Math.random() * randomRoles.length)],
      ];

      talentRoles = randomRoles.map((tag) => {
        return this.props.suggestedRoles.map((role) => {
          if (
            typeof role !== 'undefined' &&
            (role.slug.replace('-', '') === tag ||
              role.slug_plural.replace('-', '') === tag)
          ) {
            return (
              <div className="text-center mb--">
                <a
                  href={'/find/' + role.slug_plural}
                  style={{ color: 'white' }}
                >
                  Hire {aOrAn(role.name)} {role.name}
                </a>
              </div>
            );
          }
        });
      });
    }

    if (
      talentRoles !== this.state.talentRoles ||
      talentSkills !== this.state.talentSkills
    ) {
      this.setState({ talentRoles, talentSkills });
    }
  }

  render() {
    if (this.state.talentRoles.length <= 0 && this.state.talentSkills <= 0) {
      return <noscript />;
    }

    return (
      <Panel
        bsStyle="primary"
        style={{ backgroundColor: '#40a0f5', padding: '10px' }}
      >
        <div className="fs-16 text-center lato-bold mb-">
          <Link to="/hire-a-freelancer" style={{ color: 'white' }}>
            Get quality freelance talent
          </Link>
        </div>
        {this.state.talentRoles}
        {this.state.talentSkills}
      </Panel>
    );
  }
}
